import adminDashboardService from '../../services/admin/AdminDashboardService'

/**
 * Estado inicial isolado em uma factory para que RESET possa devolver o
 * módulo ao ponto zero. A tela inicial chama resetDashboard() no
 * beforeDestroy(): sair de /inicio não deve deixar os agregados pendurados no
 * Vuex.
 */
const initialState = () => ({
  moeda: null,
  catalogos: null,
  orcamentos: null,
  vendas: null,
  serie: [],
  topItens: [],
  loaded: false,
  loading: false,
  loadingItens: false,
})

/**
 * Sequência das requisições em voo. Trocar de período/filial rápido deixa mais
 * de uma consulta pendente, e a mais antiga não pode sobrescrever a resposta
 * da mais recente (nem desligar o loading dela).
 *
 * São dois contadores porque resumo e ranking viajam em requisições separadas
 * e chegam fora de ordem — o ranking é bem mais lento. Um contador só faria a
 * chegada de um invalidar o outro.
 */
let requestId = 0
let itensRequestId = 0

export const adminDashboardModule = {
  namespaced: true,

  state: initialState(),

  mutations: {
    SET_DASHBOARD(state, payload) {
      state.moeda = payload?.moeda || null
      state.catalogos = payload?.catalogos || null
      state.orcamentos = payload?.orcamentos || null
      state.vendas = payload?.vendas || null
      state.serie = payload?.serie || []
      state.loaded = true
    },
    SET_TOP_ITENS(state, topItens) {
      state.topItens = topItens || []
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_LOADING_ITENS(state, loading) {
      state.loadingItens = loading
    },
    RESET(state) {
      Object.assign(state, initialState())
    },
  },

  actions: {
    async fetchDashboard({ commit }, params = {}) {
      const current = ++requestId
      commit('SET_LOADING', true)

      try {
        const data = await adminDashboardService.getDashboard(params)

        if (current !== requestId) return data

        commit('SET_DASHBOARD', data)
        return data
      } finally {
        if (current === requestId) commit('SET_LOADING', false)
      }
    },

    /**
     * Ranking de itens. Disparado em paralelo ao resumo: enquanto não chega, a
     * tela mostra o skeleton só do card de itens, e não da página inteira.
     */
    async fetchTopItens({ commit }, params = {}) {
      const current = ++itensRequestId
      commit('SET_LOADING_ITENS', true)

      try {
        const data = await adminDashboardService.getTopItens(params)

        if (current !== itensRequestId) return data

        commit('SET_TOP_ITENS', data?.topItens)
        return data
      } finally {
        if (current === itensRequestId) commit('SET_LOADING_ITENS', false)
      }
    },

    resetDashboard({ commit }) {
      // Invalida o que estiver em voo: sair de /inicio não pode repovoar o
      // módulo depois do RESET.
      requestId++
      itensRequestId++
      commit('RESET')
    },
  },

  getters: {
    moeda: (state) => state.moeda,
    catalogos: (state) => state.catalogos,
    orcamentos: (state) => state.orcamentos,
    vendas: (state) => state.vendas,
    serie: (state) => state.serie,
    topItens: (state) => state.topItens,
    loaded: (state) => state.loaded,
    loading: (state) => state.loading,
    loadingItens: (state) => state.loadingItens,
  },
}
